import { render, staticRenderFns } from "./ImportArticles.vue?vue&type=template&id=6d494744&scoped=true"
import script from "./ImportArticles.vue?vue&type=script&lang=js"
export * from "./ImportArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d494744",
  null
  
)

export default component.exports